import React from "react";
import { Button } from "antd";
import styles from "./index.module.scss";
import successIcon from "../../images/success.svg";
import errorIcon from "../../images/error.svg";
import questionIcon from "../../images/question.svg";

const GenericPopup = ({
    visible = false,
    onClose,
    type = "success",
    title = "",
    message = "",
    primaryButtonText = "Yes",
    secondaryButtonText = "Cancel",
    onPrimaryAction,
    onSecondaryAction,
    okButtonText = "OK",
    onOk,
    loading = false,
    primaryButtonLoading = false,
    secondaryButtonLoading = false,
    primaryButtonType = "primary",
    secondaryButtonType = "default",
    primaryButtonDanger = false,
    primaryButtonDisabled = false,
    maskClosable = true,
    children
}) => {
    const getIcon = () => {
        switch (type) {
            case "success":
                return successIcon;
            case "error":
                return errorIcon;
            case "question":
                return questionIcon;
            default:
                return successIcon;
        }
    };

    const getDefaultTitle = () => {
        switch (type) {
            case "success":
                return "Success";
            case "error":
                return "Oops, Something Went Wrong";
            case "question":
                return "Are You Sure?";
            default:
                return "Notification";
        }
    };

    const renderButtons = () => {
        if (type === "question") {
            return (
                <div style={{ display: 'flex', gap: '16px' }}>
                    <Button
                        type={secondaryButtonType}
                        onClick={onSecondaryAction || onClose}
                        loading={secondaryButtonLoading}
                        style={{
                            flex: 1,
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: '#DFEDFF',
                            color: '#1B8EF8',
                            border: 'none',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}
                    >
                        {secondaryButtonText}
                    </Button>
                    <Button
                        type={primaryButtonType}
                        danger={primaryButtonDanger}
                        onClick={onPrimaryAction}
                        loading={primaryButtonLoading}
                        disabled={primaryButtonLoading || primaryButtonDisabled}
                        style={{
                            flex: 1,
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: (primaryButtonLoading || primaryButtonDisabled) ? '#C2C2C2' : '#1B8EF8',
                            color: 'white',
                            border: 'none',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}
                    >
                        {primaryButtonText}
                    </Button>
                </div>
            );
        } else {
            return (
                <Button
                    type="primary"
                    onClick={onOk || onClose}
                    loading={loading}
                    style={{
                        width: '100%',
                        height: '50px',
                        borderRadius: '8px',
                        backgroundColor: '#DFEDFF',
                        color: '#1B8EF8',
                        border: 'none',
                        fontSize: '14px',
                        fontWeight: '500'
                    }}
                >
                    {okButtonText}
                </Button>
            );
        }
    };

    if (!visible) return null;

    const isConfirmationWithInput = type === "question" && children;
    const popupHeight = isConfirmationWithInput ? '450px' : '300px';

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10000,
                padding: '20px'
            }}
            onClick={maskClosable ? onClose : undefined}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                    width: '400px',
                    height: popupHeight,
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}
                className={styles.genericPopup}
            >
                <div style={{ padding: '24px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div style={{ textAlign: 'center', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <div style={{ marginBottom: '16px' }}>
                            <img
                                src={getIcon()}
                                alt={`${type} icon`}
                                style={{ width: '96px', height: '96px' }}
                            />
                        </div>

                        <div style={{ marginBottom: '12px' }}>
                            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#333' }}>
                                {title || getDefaultTitle()}
                            </h3>
                        </div>

                        {message && (
                            <div style={{ marginBottom: '16px' }}>
                                <p style={{ margin: 0, fontSize: '14px', color: '#666', lineHeight: '1.4' }}>
                                    {message}
                                </p>
                            </div>
                        )}

                        {children}
                    </div>

                    <div>
                        {renderButtons()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GenericPopup;
